module.exports = __webpack_public_path__ + "build/img/POSITIVE.ef279ddb.svg";